export const TEAM_PEOPLE_PANEL_MIN_WIDTH_PX = 0;
export const TEAM_PEOPLE_PANEL_MAX_WIDTH_PX = 600;

/** Default people column width (`_team.sass` flex-basis). */
export const TEAM_PEOPLE_PANEL_DEFAULT_WIDTH_PX = 260;

/**
 * Width for the team people (downline) column from a viewport pointer X and panel left edge.
 *
 * @param {number} pointerX
 * @param {number} panelLeft
 * @returns {number|null} pixel width when in range, otherwise null (no update)
 */
export function resolveTeamPeoplePanelResizeWidth(pointerX, panelLeft) {
    const width = pointerX - panelLeft;

    if (
        width < TEAM_PEOPLE_PANEL_MIN_WIDTH_PX ||
        width > TEAM_PEOPLE_PANEL_MAX_WIDTH_PX
    ) {
        return null;
    }

    return width;
}
